<div class="form-group">
  <label class="control-label">
    <span class="form-label" *ngIf="label && label.length > 0">{{ label }} </span>
    <input
      class="form-control"
      name="dp"
      ngbDatepicker
      #d="ngbDatepicker"
      (click)="d.toggle()"
      id="termsDate"
      [attr.placeholder]="placeholder"
      [formControl]="date"
      [minDate]="minDate"
      [startDate]="startDate"
    />
  </label>
  <ng-content select="[rx-error]"></ng-content>

  <div rx-error *ngIf="error" class="rx-error">{{ error }}</div>
</div>
